import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { Constants } from 'utils';
import Header from './header';
import $ from 'jquery';
import { ArrowUp, ArrowBottom, Menu as MenuIcons, MenuIcon } from 'assets/icons';
// import { useSelector } from 'react-redux'; // <-- Eliminado: No se puede usar en Class Components
import { RootState } from 'reducers';

interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code: string;
	isLogout?: boolean;
}

class Menu extends React.Component<any> {
	// const user = useSelector(...); <-- Eliminado: El usuario ya viene en this.props.user gracias a connect()

	state: any = {
		leftOpen: this.props.sidebar,
		openResponsive: false,
		items: [
			{ name: 'Inicio', path: '/home', icon: MenuIcons.Menu1, iconActive: MenuIcons.Menu1 },
			{ name: 'Gestión de usuarios', path: '/admin/register', icon: MenuIcons.Menu6, iconActive: MenuIcons.Menu6, permission: Constants.MODULES.REGISTER },
			{ name: 'Registro de pagos', path: '/admin/payments', icon: MenuIcons.pagos, iconActive: MenuIcons.pagos, permission: Constants.MODULES.REGISTER },
			{ name: 'Planes y tarifas', path: '/admin/plans', icon: MenuIcons.Menu5, iconActive: MenuIcons.Menu5, permission: Constants.MODULES.PLANS, },
			{ name: 'Gestión de publicidad', path: '/admin/advertisement', icon: MenuIcons.Menu11, iconActive: MenuIcons.Menu11, permission: Constants.MODULES.PLANS, },
			{ name: 'Comisiones', path: '/admin/commissions', icon: MenuIcons.Menu14, iconActive: MenuIcons.Menu14, permission: Constants.MODULES.COMMISSIONS, },
			{ name: 'Cuentas bancarias', path: '/admin/banks', icon: MenuIcons.Menu7, iconActive: MenuIcons.Menu7, permission: Constants.MODULES.BANK_ACCOUNTS },
			{ name: 'Categorías', path: '/admin/categories', icon: MenuIcons.Menu12, iconActive: MenuIcons.Menu12, permission: Constants.MODULES.REGISTER },
			{ name: 'Notificaciones', path: '/admin/notifications', icon: MenuIcons.Menu13, iconActive: MenuIcons.Menu13, permission: Constants.MODULES.REGISTER },
			{ name: 'Calificaciones', path: '/admin/califications', icon: MenuIcons.Calification, iconActive: MenuIcons.Calification, permission: Constants.MODULES.REGISTER },
		],
		items_clinic: [
			{ name: 'Inicio', path: '/clinic/home', icon: MenuIcons.Menu0, iconActive: MenuIcons.Menu0 },
			{ name: 'Teleconsultas', path: '/affiliate/teleconsultation', icon: MenuIcons.Menu16, iconActive: MenuIcons.Menu16 },
			{ name: 'Afiliaciones y pagos', path: '/affiliate/plan', icon: MenuIcons.Menu17, iconActive: MenuIcons.Menu17 },
			{ name: 'Publicidad contratada', path: '/affiliate/ads', icon: MenuIcons.Menu18, iconActive: MenuIcons.Menu18 },
			{ name: 'Chat', path: '/clinic/chat', icon: MenuIcons.Menu15, iconActive: MenuIcons.Menu15 },
		],
		items_doctor: [
			{ name: 'Inicio', path: '/doctor/home', icon: MenuIcons.Menu0, iconActive: MenuIcons.Menu0 },
			{ name: 'Teleconsultas', path: '/affiliate/teleconsultation', icon: MenuIcons.Menu16, iconActive: MenuIcons.Menu16 },
			{ name: 'Afiliaciones y pagos', path: '/affiliate/plan', icon: MenuIcons.Menu17, iconActive: MenuIcons.Menu17 },
			{ name: 'Publicidad contratada', path: '/affiliate/ads', icon: MenuIcons.Menu18, iconActive: MenuIcons.Menu18 },
			{ name: 'Chat', path: '/doctor/chat', icon: MenuIcons.Menu15, iconActive: MenuIcons.Menu15 },
		],
		items_business: [
			{ name: 'Inicio', path: '/business/home', icon: MenuIcons.Menu0, iconActive: MenuIcons.Menu0 },
			// { name: 'Teleconsultas', path: '/affiliate/teleconsultation', icon: MenuIcons.Menu16, iconActive: MenuIcons.Menu16 },
			{ name: 'Afiliaciones y pagos', path: '/affiliate/plan', icon: MenuIcons.Menu17, iconActive: MenuIcons.Menu17 },
			{ name: 'Publicidad contratada', path: '/affiliate/ads', icon: MenuIcons.Menu18, iconActive: MenuIcons.Menu18 },
			{ name: 'Chat', path: '/business/chat', icon: MenuIcons.Menu15, iconActive: MenuIcons.Menu15 },
		]
	}

	toggleSidebar = () => {
		let key: any = `leftOpen`;
		// @ts-ignore
		this.setState({ [key]: !this.state[key] }, () => {
			this.props.dispatch({
				type: 'SET_SIDEBAR',
				payload: this.state.leftOpen
			});
		});
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) != -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) != -1;
		}
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
			openResponsive: !this.state.openResponsive
		});
	}

	closeResponsive = () => {
		this.setState({
			openResponsive: !this.state.openResponsive
		});
	}

	render() {

		let leftOpen = !this.props.isAuth && this.state.leftOpen ? "open" : "closed";
		let items = [];

		if (this.props.user) {
			switch (this.props.user?.level_id) {
				case Constants.LEVELS.ADMIN:
					items = this.state.items;
					break;

				case Constants.LEVELS.MODERATOR:
					items = this.state.items;
					break;

				case Constants.LEVELS.AFFILIATE:
					if (this.props.user?.affiliate_type == Constants.AFFILIATE_TYPES.CLINIC) {
						items = this.state.items_clinic;
					} else if (this.props.user?.affiliate_type == Constants.AFFILIATE_TYPES.MEDIC) {
						items = this.state.items_doctor;
					} else {
						items = this.state.items_business;
					}

					// Si no ha realizado el pago inicial, se le deshabilita el menú
					if (
						!this.props.user.last_payment ||
						moment(this.props.user?.last_payment?.next_payment).isBefore(moment()) ||
						this.props.user.verification === 0
					) {
						items = [items[0]];
					}
					break;

				case Constants.LEVELS.SELLER:
					items = this.state.items_clinic;
					break;
			}
		}

		return (
			<React.Fragment>
				{
					items.length > 0 && (
						<nav className="navbar navbar-expand-md bg-dark navbar-dark fixed-top justify-content-start">
							<button className="navbar-toggler" type="button" onClick={this.toggleResponsive}>
								<img src={MenuIcon} />
							</button>
						</nav>
					)
				}

				<div id="left" className={leftOpen}>
					<div className={`sidebar ${leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '')}`}>
						<div className={`shadow-close ${this.state.openResponsive ? 'open' : ''}`} onClick={this.closeResponsive}></div>
						<div className="container-menu">
							<div className={`menu ${leftOpen}`} data-alt-desing={String(Boolean(this.props.user?.level_id === Constants.LEVELS.AFFILIATE))}>
								<div className="container-scroll">
									<button className={`navbar-toggler navbar-toggler-menu ${leftOpen}`} type="button" onClick={() => {
										this.toggleSidebar();
									}}>
										<img src={MenuIcon} />
									</button>
									<button className={`navbar-toggler navbar-toggler-menu responsive ${leftOpen}`} type="button" onClick={() => {
										this.toggleResponsive();
									}}>
										<img src={MenuIcon} />
									</button>
									<ul className={leftOpen}>
										{items.map((i: MenuItem, index: number) => {
											return (
												<React.Fragment key={index}>
													{
														(!i.permission || this.checkPermission(i)) && (
															<li className="nav-item">
																<Link to={i.path} className={`${i.submenu && i.submenu.length > 0 ? 'contain-submenu' : ''}`} onClick={(e: any) => {
																	if (i.onClick) {
																		e.preventDefault();
																		i.onClick();
																	}
																	else {
																		if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path, this.props.history.location.pathname) && this.props.open_menu) {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: false
																			});
																			e.preventDefault();
																		}
																		else {
																			this.props.dispatch({
																				type: 'SET_OPEN_MENU',
																				payload: true
																			});
																			this.changeMenu(i);
																			this.closeResponsive();
																		}
																	}
																}}>
																	<div className={`container-icon-menu ${this.checkActive(i.path, this.props.history.location.pathname) ? 'active' : ''}`}>
																		{
																			i.icon && (
																				<img src={this.checkActive(i.path, this.props.history.location.pathname) ? i.iconActive : i.icon} />
																			)
																		}
																	</div>
																	<span className={leftOpen}>
																		{i.name}
																		{
																			i.submenu && i.submenu.length > 0 && (
																				<React.Fragment>
																					{
																						this.checkActive(i.path, this.props.history.location.pathname) ? (
																							<img className="arrow-drop" src={this.props.open_menu ? ArrowUp : ArrowBottom} />
																						) : (
																							<img className="arrow-drop" src={ArrowBottom} />
																						)
																					}
																				</React.Fragment>
																			)
																		}
																	</span>
																</Link>
																{
																	this.props.open_menu && (
																		<div className={`${i.submenu && i.submenu.length > 0 && this.checkActive(i.path, this.props.history.location.pathname) ? 'container-submenu' : ''}`}>
																			{
																				leftOpen != 'closed' && this.checkActive(i.path, this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem, index: number) => {
																					if (!item.permission || this.checkPermission(item)) {
																						return (
																							<li className={'nav-item item-submenu ' + (this.props.history.location.pathname == item.path ? 'active' : '')}>
																								<Link to={item.path} className="submenu">
																									{
																										item.icon && (
																											<img src={item.icon} />
																										)
																									}
																									{item.name}
																								</Link>
																							</li>
																						)
																					}
																				})
																			}
																		</div>
																	)
																}
															</li>
														)
													}
												</React.Fragment>
											)
										})}
									</ul>
								</div>
							</div>
						</div>
						<div className={`container-router ${leftOpen}`}>
							<Header className={leftOpen + ' ' + (items.length > 0 && 'header-responsive')} />
							<div className={`container-padding-router ${items.length > 0 && 'container-responsive'}`}>{this.props.children}</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		sidebar: state.sidebar
	}
})(Menu);